import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { CogIcon, PlusIcon } from '@heroicons/react/24/outline';
import { api } from '../../services/api';

const Equipment: React.FC = () => {
  const { data: equipmentData, isLoading } = useQuery({
    queryKey: ['equipment'],
    queryFn: () => api.get('/equipment'),
  });

  const equipment = equipmentData?.data?.equipment || [];

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Equipment</h1>
          <p className="text-gray-600">Manage your equipment inventory</p>
        </div>
        <div className="mt-4 sm:mt-0">
          <button className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700">
            <PlusIcon className="h-5 w-5 mr-2" />
            Add Equipment
          </button>
        </div>
      </div>

      <div className="bg-white shadow rounded-lg">
        <div className="px-4 py-5 sm:p-6">
          {equipment.length > 0 ? (
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
              {equipment.map((item: any) => (
                <div
                  key={item.id}
                  className="bg-gray-50 rounded-lg p-4 hover:shadow-md transition-shadow"
                >
                  <div className="flex items-center">
                    <CogIcon className="h-8 w-8 text-blue-500 mr-3" />
                    <div>
                      <h3 className="text-lg font-medium text-gray-900">
                        {item.name}
                      </h3>
                      <p className="text-sm text-gray-500">
                        {item.category}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-12">
              <CogIcon className="mx-auto h-12 w-12 text-gray-400" />
              <h3 className="mt-2 text-sm font-medium text-gray-900">No equipment</h3>
              <p className="mt-1 text-sm text-gray-500">
                Get started by adding equipment to your inventory.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Equipment;
